angular.module('access.Session')
    .constant('PRESENTATION_API_BASE_URL', '/api/presentation/v1')
    .factory('CloudPlatformPresentation', [
        'CloudPlatformAccountServerRequest',
        'PRESENTATION_API_BASE_URL',
        function (CloudPlatformAccountServerRequest, PRESENTATION_API_BASE_URL) {
            var LICENSES_API_ENDPOINT = PRESENTATION_API_BASE_URL + '/presentations/public/com.acronis.platform.licensing.dc-info';
            var BRANDING_SETTINGS_ENDPOINT = PRESENTATION_API_BASE_URL + '/branding-settings/';
            var DEFAULT_PRIVACY_POLICY_LINK = 'https://acronis.com/en-eu/company/privacy/';
            var DEFAULT_TERMS_LINK = 'https://acronis.com/en-eu/support/eula.html';

            return {
                getPresentationLinks: function () {
                    return CloudPlatformAccountServerRequest.get(LICENSES_API_ENDPOINT)
                        .then(function (response) {
                            var links = response.presentation && response.presentation.links ? response.presentation.links :
                                [];

                            return links.sort(function (link1, link2) {
                                return link1.order > link2.order ? 1 : -1;
                            });
                        });
                },
                getBrandingSettings: function(brandId) {
                    return CloudPlatformAccountServerRequest.get(BRANDING_SETTINGS_ENDPOINT + brandId)
                        .then(function (brandingSettings) {
                            if (brandingSettings.branding_info.privacy_policy_url !== '' || brandingSettings.branding_info.terms_url !== '') {
                                return brandingSettings;
                            }

                            // Default branding settings are stored at /1 that's why we pass 1 as argument
                            return CloudPlatformAccountServerRequest.get(BRANDING_SETTINGS_ENDPOINT + 1);
                        });
                },
                getPrivacyAndTermsLinks: function(brandId) {
                    return this.getBrandingSettings(brandId)
                        .then(function (brandingSettings) {
                            var pageLocale = document.documentElement.lang;
                            var brandingInfo =  brandingSettings.branding_info;

                            return {
                                privacyUrl: brandingInfo.privacy_policy_url,
                                termsUrl: brandingInfo.terms_url.replace(/\[Language\]/gi, pageLocale)
                            }
                            
                        })
                        .catch(function () {
                            return {
                                privacyUrl: DEFAULT_PRIVACY_POLICY_LINK,
                                termsUrl: DEFAULT_TERMS_LINK
                            };
                        })
                }
            }
        }
    ]);
